export default "__VITE_ASSET__DfwKOJFo__"